const [ w, d ] = [ window, document ]

export default function PAGE_TRANSITION (promise) {
  const root = d.documentElement
  
  root.classList.add('is--loading')

  promise.done(() => root.classList.remove('is--loading') )
}